import React from 'react';
import styled from 'styled-components';
import { Carousel } from 'react-bootstrap';

const StyledCarousel = styled(Carousel)`
    .carousel-indicators li { 
        visibility: hidden; 
    }

    .carousel-inner img {
      margin: auto;
    }
`;

const Screenshots = (props) => (
    <StyledCarousel interval={null} slide={false}>
        {
            props.screenshots.map((path, index) => (
                <Carousel.Item key={index}>
                    <img alt={'screenshot ' + index} src={process.env.PUBLIC_URL + path}/>
                </Carousel.Item>
            ))
        }
    </StyledCarousel>
);

export default Screenshots;


// WEBPACK FOOTER //
// ./src/components/GameInfo/Screenshots.js